import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import StartStopJobCardModal from "./StartStopJobCardModal";
import StartJobCardList from "./StartJobCardList";
import Constants from "../../../../common/Constants";
import { Row, Col, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import ItemService from "../../../../services/commonService";
import ListGroup from "react-bootstrap/ListGroup";
import { fetchMasterListById } from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import Form from "react-bootstrap/Form";
import { toastFunc } from "../../../../components/common/util";
import { useNavigate } from "react-router-dom";
import { AlertModal } from "../../../common/AlertModal";
import { ErrorModal } from "../../../common/errorModal";
import moment from "moment";

const StartStopJobCard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [open, setOpen] = useState(false);
  const [jobcardDetails, setJobcardDetails] = useState(true);
  const [jobcardList, setJobcardList] = useState([]);
  const [toDeptCode, setToDeptCode] = useState("");
  const [toDeptName, setToDeptName] = useState("");
  const [toMachineCode, setToMachineCode] = useState("");
  const [finalToMachineCode, setFinalToMachineCode] = useState("");
  const [finalToMachineName, setFinalToMachineName] = useState("");
  const [toMachineName, setToMachineName] = useState("");
  const [fromValue, setFromValue] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [jobcardTransactionPageId, setJobcardTransactionPageId] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);
  const [machineList, setMachineList] = useState([]);
  const [sizeCode, setSizeCode] = useState("");
  const [alertValue, setAlertValue] = useState("");
  const [errorValue, setErrorValue] = useState("");
  const [fetchByDeptCode, setFetchByDeptCode] = useState("");
  const [showChemicalBatch, setShowChemicalBatch] = useState("");
  const [fetchBySelectedMachineCode, setFetchBySelectedMachineCode] =
    useState("");
  const [fetchBySelectedMachineName, setFetchBySelectedMachineName] =
    useState("");
  const [targetDuration, setTargetDuration] = useState(0);
  const formRef = useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    navigate("/home");
    setOpen(false);
    setJobcardList([]);
  };

  useEffect(() => {
    if (location?.state?.jobcardNo) {
      handleStartStopSuccess(location?.state?.jobcardNo, "", true);
      setOpen(false);
    } else if (location?.state?.deptCode) {
      setFetchByDeptCode(location?.state?.deptCode);
      setFetchBySelectedMachineCode(location?.state?.machineCode);
      setFetchBySelectedMachineName(location?.state?.machineName);
      handleInputValue(location?.state?.deptCode, "dept");
      setOpen(false);
    } else if (!toDeptCode) {
      setTimeout(() => {
        setOpen(true);
      }, 100);
    }
    // eslint-disable-next-line
  }, []);

  const getChemicalBatchByDept = async (deptCode) => {
    let param = {
      deptCode,
    };
    await ItemService.getChemicalBatchByDept(param).then((item) => {
      // console.log(">>setShowChemicalBatch Details res!", item);
      if (item?.status === 200) {
        setShowChemicalBatch(item.data[0]);
      }
    });
  };

  const handleFetchJobCardListByDept = async (decodedText, decodedResult) => {
    if (isProcessing) return; // Prevent multiple calls while processing
    setOpen(false);
    setToDeptCode(decodedText);
    setIsProcessing(true); // Set processing lock

    let param = {
      url: "getTransactionListDataByDept",
      page: Constants.TRANSACTION.GENERATEJOBCARD.name,
      deptCode: decodedText,
    };

    if (decodedText) {
      try {
        const item = await ItemService.getTransactionListDataById(param);
        if (item?.status === 200) {
          if (item?.data.length > 0) {
            setOpen(false);
            setJobcardList(item.data);
          } else {
            if (decodedResult !== "") {
              handleClose();
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000
              );
            } else {
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000
              );
            }
          }
        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      } catch (error) {
        console.error("Error in handleStartStopSuccess:", error);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
          4000
        );
      } finally {
        setIsProcessing(false); // Reset lock after completion
      }
    } else {
      setIsProcessing(false); // Reset lock if no decodedText is provided
    }
  };

  const handleStartStopSuccess = async (decodedText, decodedResult, fromCheckList=false) => {
    if (isProcessing) return; // Prevent multiple calls while processing

    setIsProcessing(true); // Set processing lock

    let tempMachineCode = '';
    let tempMachineName = '';

    if(fromCheckList){
      tempMachineCode = location.state?.machineCode
      tempMachineName = location.state?.machineName
    }
    let param = {
      url: "getTransactionListDataById",
      page: Constants.TRANSACTION.GENERATEJOBCARD.name,
      jobcard: decodedText,
    };

    if (decodedText) {
      try {
        const item = await ItemService.getTransactionListDataById(param);
        if (item?.status === 200) {
          if (item?.data.length > 0) {
            if (
              item?.data[0]?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.OPEN ||
              item?.data[0]?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.COMPLETE
            ) {
              handleClose();
              if (
                item?.data[0]?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.COMPLETE
              ) {
                toastFunc(
                  Constants.MASTER.TOAST.error,
                  "Jobcard Completed",
                  5000
                );
              } else {
                toastFunc(
                  Constants.MASTER.TOAST.error,
                  "Job Card not Acknowledged",
                  5000
                );
              }
            } else {
              setOpen(false);
              setJobcardDetails(item.data[0]);
              setToDeptCode(item?.data[0]?.toDeptCode);
              setToDeptName(item?.data[0]?.toDeptName);
              setToMachineCode(item?.data[0]?.toMachineCode ? item?.data[0]?.toMachineCode : tempMachineCode);
              setToMachineName(item?.data[0]?.toMachineName ? item?.data[0]?.toMachineName : tempMachineName);
              setFinalToMachineCode(item?.data[0]?.toMachineCode ? item?.data[0]?.toMachineCode : tempMachineCode);
              setFinalToMachineName(item?.data[0]?.toMachineName ? item?.data[0]?.toMachineName : tempMachineName);
              setSizeCode(item?.data[0]?.sizeCode);
              await getChemicalBatchByDept(item?.data[0]?.toDeptCode);
            }
          } else {
            if (decodedResult !== "") {
              handleClose();
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000
              );
            } else {
              toastFunc(
                Constants.MASTER.TOAST.error,
                t("msg_trasaction.msg_teamlead_acknowledge.jobcard_not_found"),
                4000
              );
            }
          }
        } else {
          console.log(">> Error: Loading getApplicationMaster");
        }
      } catch (error) {
        console.error("Error in handleStartStopSuccess:", error);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_trasaction.msg_teamlead_acknowledge.error_occurred"),
          4000
        );
      } finally {
        setIsProcessing(false); // Reset lock after completion
      }
    } else {
      setIsProcessing(false); // Reset lock if no decodedText is provided
    }
  };

  useEffect(() => {
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = toDeptCode;

    if (toDeptCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        let filteredMachines = result?.payload?.data.filter(
          (machine) =>
            machine.runningStatus !== "Inuse" &&
            machine.status !== Constants.MASTER.STATUS.Inactive
        );
        if (toMachineCode) {
          const selectedMachineRow = {
            machineCode: toMachineCode,
            machineName: toMachineName,
          };
          filteredMachines.push(selectedMachineRow);
        }
        setMachineList(filteredMachines);
      });
    }
  }, [dispatch, toDeptCode, toMachineCode, toMachineName]);

  useEffect(() => {
    let param = {};
    param.url = "getProcessMasterListDataById";
    param.page = Constants.MASTER.PROCESS.name;
    param.id = sizeCode;

    if (sizeCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        if (result?.payload?.data[0]) {
          let processFilter = result?.payload?.data[0]?.process.filter(
            (process) => process.deptCode === toDeptCode
          );
          setTargetDuration(processFilter[0]?.cycleTime * 60);
        } else {
          setIsAlert(true);
          setAlertValue(
            "Process Not set for Jobcard. Please set the process to proceed."
          );
          navigate("/home");
          setOpen(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeCode]);

  const handleStartStopError = (errorMessage) => {
    console.error("ACK handleStartStopError:", errorMessage);
  };

  const handleInputValue = (value, action) => {
    if (action === "dept") {
      setFetchByDeptCode(value);
      handleFetchJobCardListByDept(value);
    } else {
      handleStartStopSuccess(value, "");
    }
  };
  const resetAlert = () => {
    setIsAlert(false);
  };
  const resetError = () => {
    setIsError(false);
    setErrorValue("");
  };
  const handleStartStop = async (type) => {
    if (finalToMachineCode || jobcardDetails.toMachineCode) {
      try {
        setDisableBtn(true);
        const startStopForm = {
          fromDeptCode: jobcardDetails.fromDeptCode,
          fromDeptName: jobcardDetails.fromDeptName,
          fromMachineCode: jobcardDetails.fromMachineCode,
          fromMachineName: jobcardDetails.fromMachineName,
          toDeptCode: toDeptCode,
          toDeptName: toDeptName,
          toMachineCode: finalToMachineCode
            ? finalToMachineCode
            : jobcardDetails.toMachineCode,
          toMachineName: finalToMachineName
            ? finalToMachineCode
            : jobcardDetails.toMachineName,
          jobcard: jobcardDetails.jobcard,
          batchTotalQuantity: jobcardDetails.batchTotalQuantity,
          sizeCode: jobcardDetails.sizeCode,
          sizeName: jobcardDetails.sizeName,
          jobcardStatus:
            type === "start"
              ? Constants.TRANSACTION_STATUS.INPROGRESS
              : Constants.TRANSACTION_STATUS.STOPPED,
          fromDB: type === "start" ? moment().toDate() : new Date(fromValue),
          toDB: type === "start" ? "" : moment().toDate(),
          from:
            type === "start"
              ? moment().format("DD-MM-YYYY HH:mm:ss")
              : fromValue,
          to: type === "start" ? "" : moment().format("DD-MM-YYYY HH:mm:ss"),
          actualDuration: "",
          targetDuration: targetDuration,
          pageId: type === "start" ? "" : jobcardTransactionPageId,
          chemicalBatchNo: showChemicalBatch?.chemicalBatchNo,
          chemicalName: showChemicalBatch?.chemicalName,
        };
        const param = {};
        param.url = type === "start" ? "startJobcard" : "stopJobcard";
        param.startStopForm = startStopForm;

        await ItemService.startStopJobcard(param).then((item) => {
          if (item?.status === 200) {
            if (item) {
              toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
              if (type === "start") {
                setFromValue(item.fromValue);
              }
              handleInputValue(jobcardDetails.jobcard, "");
            } else {
            }
          } else {
            console.log(">> Error: Loading getApplicationMaster");
          }
          setTimeout(() => {
            setDisableBtn(false);
          }, 500);
        });
      } catch (error) {
        console.log(">> Error: Loading getApplicationMaster", error);
      }
    } else {
      setIsAlert(true);
      setAlertValue(t("msg_trasaction.startstop_jobcard.select_machine"));
    }
  };

  const handleMultipleStart = async (selectedItems, toMachineCode) => {
    try {
      let startStopFormList = [];
      setDisableBtn(true);
      selectedItems?.forEach((element) => {
        if (element && toMachineCode) {
          const startStopForm = {
            fromDeptCode: element.fromDeptCode,
            fromDeptName: element.fromDeptName,
            fromMachineCode: element.fromMachineCode,
            fromMachineName: element.fromMachineName,
            toDeptCode: element.toDeptCode,
            toDeptName: element.toDeptName,
            toMachineCode: finalToMachineCode
              ? finalToMachineCode
              : toMachineCode,
            toMachineName: finalToMachineName
              ? finalToMachineCode
              : toMachineCode,
            jobcard: element.jobcard,
            batchTotalQuantity: element.batchTotalQuantity,
            sizeCode: element.sizeCode,
            sizeName: element.sizeName,
            jobcardStatus: Constants.TRANSACTION_STATUS.INPROGRESS,
            fromDB: moment().toDate(),
            toDB: "",
            from: moment().format("DD-MM-YYYY HH:mm:ss"),
            to: "",
            actualDuration: "",
            targetDuration: targetDuration,
            pageId: "",
            chemicalBatchNo: showChemicalBatch?.chemicalBatchNo,
            chemicalName: showChemicalBatch?.chemicalName,
          };
          startStopFormList.push(startStopForm);
        } else {
          setIsAlert(true);
          setDisableBtn(false);
          setAlertValue(t("msg_trasaction.startstop_jobcard.select_machine"));
        }
      });

      const param = {};
      param.url = "startMultipleJobcard";
      param.startStopFormList = startStopFormList;
      if (startStopFormList.length > 0) {
        await ItemService.startStopJobcard(param).then((item) => {
          if (item?.status === 200) {
            if (item) {
              toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
              setFromValue(item.fromValue);
              handleInputValue(jobcardDetails.jobcard, "");
              handleFetchJobCardListByDept(toDeptCode);
            }
          } else {
            console.log(">> Error: Loading getApplicationMaster");
          }
          setTimeout(() => {
            setDisableBtn(false);
          }, 500);
        });
      }
    } catch (error) {
      console.log(">> Error: Loading getApplicationMaster", error);
    }
  };

  const fetchOperatorCheckListRecord = async (
    selectedItem,
    multipleMachineCode,
    multipleMachineName,
    multipleItem = false
  ) => {
    let param = {};
    try {
      const machineCode = finalToMachineCode
        ? finalToMachineCode
        : jobcardDetails.toMachineCode;
      const machineName = finalToMachineName
        ? finalToMachineCode
        : jobcardDetails.toMachineName;
      param.url = "getTodaysOperatorChecklist";
      param.page = Constants.TRANSACTION.OPERATORCHECKLIST.name;
      if (multipleItem) {
        param.machineCode = multipleMachineCode;
        param.deptCode = fetchByDeptCode;
      } else {
        param.machineCode = machineCode;
        param.deptCode = jobcardDetails?.toDeptCode;
        param.timeZone = jobcardDetails?.timeZone;
      }

      if (multipleMachineCode && selectedItem?.length === 0) {
        setIsAlert(true);
        setDisableBtn(false);
        setAlertValue(t("msg_common.selectRecord"));
      } else if (machineCode || multipleMachineCode) {
        setDisableBtn(true);
        let checkListparam = {};
        checkListparam.url = "getCheckListByMachine";
        if (multipleItem) {
          checkListparam.machineCode = multipleMachineCode;
          checkListparam.deptCode = fetchByDeptCode;
        } else {
          checkListparam.machineCode = machineCode;
          checkListparam.deptCode = jobcardDetails?.toDeptCode;
        }

        dispatch(fetchMasterListById(checkListparam)).then((result) => {
          if (result?.payload?.data?.length > 0) {
            dispatch(fetchMasterListById(param)).then((result) => {
              if (!result?.payload?.data) {
                if (multipleItem) {
                  navigate("/operatorchecklist", {
                    state: {
                      deptCode: fetchByDeptCode,
                      machineCode: multipleMachineCode,
                      machineName: multipleMachineName,
                    },
                  });
                } else {
                  navigate("/operatorchecklist", {
                    state: {
                      deptCode: jobcardDetails?.toDeptCode,
                      machineCode: machineCode,
                      machineName: machineName,
                      deptName: toDeptName,
                      jobcardNo: jobcardDetails?.jobcard,
                    },
                  });
                }
              } else {
                if (multipleItem) {
                  handleMultipleStart(selectedItem, multipleMachineCode);
                } else {
                  handleStartStop("start");
                }
              }
            });
          } else {
            setIsError(true);
            setErrorValue(t("msg_trasaction.startstop_jobcard.no_checklist"));
          }
          setTimeout(() => {
            setDisableBtn(false);
          }, 500);
        });
      } else {
        setIsAlert(true);
        setDisableBtn(false);
        setAlertValue(t("msg_trasaction.startstop_jobcard.select_machine"));

        //    setIsError(true);
        // setErrorValue("Plese Select Machine");
      }
    } catch (error) {
      setDisableBtn(false);
    }
  };

  return (
    <main className="StartStopJobCard main" id="main">
      <Form noValidate ref={formRef}>
        {jobcardList.length === 0 && (
          <Card className="">
            <Card.Header>
              <Button
                type="button"
                variant="primary"
                className="btn btn-primary btn-xs navigateBackButton"
                onClick={() => navigate("/home")}
              >
                <i class="bi bi-arrow-left back"> </i>
                <span className="back"> {t("msg_common.Back")}</span>
              </Button>

              <h5 className="machineStatusTitle">
                {" "}
                {`Start JobCard - ${jobcardDetails?.jobcard}`}
              </h5>

              {jobcardDetails?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                <p className="bg-table-status bg-table-warning-status acknowledmentStatus">
                  {jobcardDetails.jobcardStatus}
                </p>
              )}

              {jobcardDetails?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.INPROGRESS && (
                <p className="bg-table-status bg-table-success-status acknowledmentStatus">
                  {jobcardDetails.jobcardStatus}
                </p>
              )}

              {jobcardDetails?.jobcardStatus ===
                Constants.TRANSACTION_STATUS.STOPPED && (
                <p className="bg-table-status bg-table-danger-status acknowledmentStatus">
                  {jobcardDetails.jobcardStatus}
                </p>
              )}
            </Card.Header>
            <Card.Body className="ps-3">
              <Row className="ps-3 start-stop-page-header">
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>
                        {t("msg_trasaction.startstop_jobcard.from_department")}{" "}
                        :
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      {jobcardDetails.fromDeptCode && (
                        <h5>
                          <span className="bg-table-status bg-table-new-status py-0">
                            {jobcardDetails.fromDeptCode}{" "}
                            {jobcardDetails.fromDeptName}
                          </span>
                        </h5>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>
                        {t("msg_trasaction.startstop_jobcard.to_department")} :
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      <h5>
                        <span className="bg-table-status bg-table-new-status py-0">
                          {jobcardDetails.toDeptCode} -{" "}
                          {jobcardDetails.toDeptName}
                        </span>
                      </h5>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="ps-3">
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={2} md={2} sm={12}>
                      <h5> Chemical :</h5>
                    </Col>
                    <Col lg={10} md={10} sm={12}>
                      {showChemicalBatch && (
                        <>
                          <span className="bg-table-status bg-table-new-status py-0 mx-1">
                            Batch: {showChemicalBatch?.chemicalBatchNo}
                          </span>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>
                        {" "}
                        {t("msg_trasaction.startstop_jobcard.to_machine")} :
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      <h5>
                        <DropdownListField
                          id="machineCode"
                          name="machineCode"
                          className="dropdownHive w-full rounded-md"
                          data={machineList}
                          value={
                            finalToMachineCode
                              ? finalToMachineCode
                              : toMachineCode
                          }
                          onChange={(e) => {
                            setFinalToMachineCode(e.machineCode);
                            setFinalToMachineName(e.machineName);
                          }}
                          placeholder={"Select To Machine"}
                          disabled={
                            jobcardDetails?.jobcardStatus === "Inprogress"
                              ? true
                              : false
                          }
                          // disabled={disableMachineArr}
                        />
                      </h5>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <Card>
                <Row>
                  <Col lg={6} md={6} sm={12}>
                    <ListGroup variant="flush" className="jobcard-detail-list">
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.customer")} :{" "}
                        </span>{" "}
                        {jobcardDetails.customerCode}{" "}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.requiredDate")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.requiredDate}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.plan")} :{" "}
                        </span>{" "}
                        {jobcardDetails.plan}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.startstop_jobcard.total_quantity")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.batchTotalQuantity}
                      </ListGroup.Item>
                      {jobcardDetails?.jobcardStatus ===
                        Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                        <ListGroup.Item className="m-2"></ListGroup.Item>
                      )}
                    </ListGroup>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <ListGroup variant="flush" className="jobcard-detail-list">
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.size")} :{" "}
                        </span>{" "}
                        {jobcardDetails.sizeCode} ({jobcardDetails.sizeName})
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.slCardNumber")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.jobcard}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.startstop_jobcard.jobCard_number")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.jobcard}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t(
                            "msg_trasaction.msg_generatejobcard.batchQuantity"
                          )}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.quantityPerJobCard}
                      </ListGroup.Item>
                      {jobcardDetails?.jobcardStatus ===
                        Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                        <ListGroup.Item></ListGroup.Item>
                      )}
                    </ListGroup>
                  </Col>
                </Row>
              </Card>
            </Card.Body>

            {
              <Card.Footer className="text-center machine-status-footer-button">
                <Button
                  type="button"
                  variant="success"
                  size="lg"
                  className="btn btn-success"
                  onClick={() => fetchOperatorCheckListRecord()}
                  data-dismiss="modal"
                  disabled={
                    jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.INPROGRESS || disableBtn
                      ? true
                      : false
                  }
                >
                  {t("msg_common.start")}
                </Button>

                <Button
                  type="button"
                  variant="danger"
                  size="lg"
                  className="btn btn-danger"
                  onClick={() => navigate("/home")}
                  data-dismiss="modal"
                >
                  {t("msg_common.set_cancel")}
                </Button>

                <Button
                  type="button"
                  variant="warning"
                  size="lg"
                  className="btn btn-warning"
                  onClick={() => handleStartStop("stop")}
                  data-dismiss="modal"
                  disabled={
                    jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.ACKNOWLEDGE ||
                    jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.STOPPED ||
                    disableBtn
                      ? true
                      : false
                  }
                >
                  {t("msg_common.stop")}
                </Button>
              </Card.Footer>
            }
          </Card>
        )}
        {open && (
          <StartStopJobCardModal
            show={open}
            onHide={handleClose}
            handleSuccess={handleStartStopSuccess}
            handleError={handleStartStopError}
            onButtonClick={handleInputValue}
            pageId={"startStopJobcard"}
            displayDept={true}
            //onSave={handleSave}
            title={t("msg_trasaction.startstop_jobcard.page_title")}
          ></StartStopJobCardModal>
        )}
      </Form>
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={alertValue}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_trasaction.startstop_jobcard.error")}
          bodyMessage={errorValue}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}
      {jobcardList?.length > 0 && (
        <StartJobCardList
          show={jobcardList?.length > 0}
          deptCode={toDeptCode}
          onHide={handleClose}
          handleSuccess={handleStartStopSuccess}
          handleError={handleStartStopError}
          onButtonClick={handleInputValue}
          pageId={"startStopJobcard"}
          rows={jobcardList}
          selectedMachineCode={fetchBySelectedMachineCode}
          selectedMachineName={fetchBySelectedMachineName}
          fetchCheckList={fetchOperatorCheckListRecord}
          startMultipleJobCards={handleMultipleStart}
          title={t("msg_trasaction.startstop_jobcard.page_title")}
        ></StartJobCardList>
      )}
    </main>
  );
};

export default StartStopJobCard;
